import { BookingOptionType } from "Types/BookingFormTypes";
import images from "../../Assets/images";
import { bookingTypes, constants } from "Library/Constants";

const information = [
  { step: 1, title: "scheduling_information" },
  { step: 2, title: "booking_date" },
  { step: 3, title: "booking_time" },
  { step: 4, title: "booking_details" },
  { step: 5, title: "additional_details" },
];

const additionalDetail = {
  flexibleFieldData: [],
  comments: "",
};

const bookingDateStatic = {
  selectedDate: "",
};

const bookingDateRepeat = {
  startDate: "",
  endDate: "",
  repeatType: constants.WEEKLY,
  repeatWeekDays: [],
  repeatMonthlyOption: "",
};

const defaultFormData = {
  schedulingInformation: null,
  bookingTime: null,
  bookingSlotDetail: null,
  additionalDetail: additionalDetail,
  bookingDate: bookingDateStatic,
};

const bookingSteps: BookingOptionType[] = [
  {
    id: 1,
    name: bookingTypes.DELIVERY,
    label: "Delivery",
    image: images.delivery,
    detail: "delivery_information_message",
    stepCount: 1,
    information: information,
    bookingWasEdited: false,
    isActive: true,
    isEditing: false,
    isRescheduling: false,
    data: {
      ...defaultFormData,
    },
  },
  {
    id: 2,
    name: bookingTypes.RECURRING,
    label: "Recurring",
    image: images.recurring,
    detail: "recurring_information_message",
    stepCount: 1,
    information: information,
    bookingWasEdited: false,
    isActive: true,
    isEditing: false,
    isRescheduling: false,
    data: {
      ...defaultFormData,
      bookingDate: bookingDateRepeat,
    },
  },
  {
    id: 3,
    name: bookingTypes.MULTI_VEHICLE,
    label: "Multi-Vehicle",
    image: images.multiVehicle,
    detail: "multivehicle_information_message",
    stepCount: 1,
    information: information,
    bookingWasEdited: false,
    isActive: true,
    isEditing: false,
    isRescheduling: false,
    data: {
      ...defaultFormData,
    },
  },
  {
    id: 4,
    name: bookingTypes.RESOURCE_ONLY,
    label: "Resource-Only",
    image: images.resource,
    detail: "resource_only_information_message",
    stepCount: 1,
    information: information,
    bookingWasEdited: false,
    isActive: true,
    isEditing: false,
    isRescheduling: false,
    data: {
      ...defaultFormData,
    },
  },
];

export default bookingSteps;
